export const SET_PROFILE = 'SET_PROFILE';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';



// WEBPACK FOOTER //
// ./src/actions/profileTypes.js